<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="12">
              <el-form-item label='SW/FW'>
                <el-select v-model="swfw" :placeholder="$t('msg.pleaseSelect')" clearable >
                  <el-option v-for="item in swfwOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col> 
            <el-col :span="12">
              <el-form-item label='Release Date'>
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>                               
          </el-row>
   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <!--Table ref="table1" :tableData="tableData" :linkAction="linkAction"/--> 
            <Table ref="tableList" :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="false" :showEditButton="true"  
             @sync-delete="deleteSwfw" @sync-save="saveSwfw" @sync-file-status="saveFileSuccess" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
//import Table from '../components/FuzzySearchTable'
import Table from '../components/EditableTableWithFile'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindSwfwByCondition, apiFindSwfwName, apiFindSwfwVersionType, apiSaveSwfw, apiDeleteSwfwById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

  
export default {
  name: 'softwareVersion',
  data() {    
    return {  
      addDataSuccess: false,     
      sdate: '',
      edate: '',
      swfw: '',
      swfwOpts:[],
      sortColumn:'',
      sortType:'',
      //versionType: '',
      //versionTypeOpts:[],
      tableData: {
        sel: null,   
        columns: [ 
          { field: "releaseDate", title: 'Release Date', width: 150, type:"date", align:'center', required:true },         
          //{ field: "versionType", title: 'Version Type' , width: 150, type:'select', required:true   },
          { field: "type", title: 'Type' , width: 140, type:'select', required:true   },
          { field: "name", title: 'SW/FW', width: 280, type:'select', notUpdate:true, required:true },
          { field: "version", title: 'Version', link:true, notUpdate:true },
          { field: "isImportant", title: this.$i18n.t('field.isImportant'), type:'select' , width: 150 },
          { field: "isPublish", title: this.$i18n.t('field.isPublish'), type:'select' , width: 120 }
        ],
        uploadType:"swfw" ,
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'swfwTable',
        exportName: this.$i18n.t('menu.softwareVersion'),

      }    
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  created(){
      this.tableData.columns.forEach((item) => {
        if(item.field == 'type'){
          item.selectObj = [{value:'software',label:'Software'},{value:'Firmware',label:'Firmware'},{value:'Updated package',label:'Updated package'},{value:'KA List',label:'KA List'}];
        }
        //if(item.field == 'versionType'){
          //item.selectObj = [{value:'Official ver.',label:'Official ver.'},{value:'Beta ver.',label:'Beta ver.'}];
        //}
        if(item.field == 'isImportant' || item.field == 'isPublish'){
          item.selectObj = [{value:'Y',label:'Y'},{value:'',label:''}];
        }
        if(item.field == 'name'){
          //item.selectObj = this.swfwOpts;
          apiFindSwfwName({ headers: authHeader()}).then((response) => { 
            item.selectObj = [];
            response.data.forEach((item2, index) => {   
              item.selectObj.push({ value: item2, label: item2 });
            });
          }).catch((err) => {
            console.log(err);
          });
        }

      });
         
  },
  mounted() {  
    apiFindSwfwName({ headers: authHeader()}).then((response) => { 
      this.swfwOpts = [];
      if(response.status== 200 && response.data != null && response.data.length > 0){
          this.swfwOpts = response.data;
      }
    }).catch((err) => {
      console.log(err);
    });

    //apiFindSwfwVersionType({ headers: authHeader()}).then((response) => { 
    //  this.versionTypeOpts = [];
    //  if(response.status== 200 && response.data != null && response.data.length > 0){
    //      this.versionTypeOpts = response.data;
    //  }
    //}).catch((err) => {
    //  console.log(err);
    //});
    this.findData()
   
  },
  methods: {
    findData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];        
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }
      apiFindSwfwByCondition({ headers: authHeader(), versionType: this.versionType, name: this.swfw, sdate : sdate, edate : edate, 
        sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
     
          response.data.forEach((item, index) => { 
             item.releaseDate = CommonUtil.dateFormatDate(new Date(item.releaseDate )); 
           //debugger;
           //item.fileName = item.version;
           //item.fileName.linkAction.afileName = item.fileName;
           // item.version = download(item.name,item.version);
             //if(item.title =='File') item.link = true;
          });              
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  
          //this.$refs.table1.$refs.filterTable.doLayout();

      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },
    saveSwfw(data, newFileData){

      if(data.length == null){
        data = [data];
      }

      apiSaveSwfw({  headers: authHeader(), swfws : data}).then((response) => {                    
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          debugger
          if(typeof newFileData != "undefined") {
          newFileData.docId = response.data;
          if(newFileData.docId!='undefined' && newFileData.docId!='')
          {
            this.addDataSuccess = true;
            this.$refs.tableList.addFile(newFileData);
          }else{
            this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
            //this.findData();
          }
          }
          this.findData();
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }       

        
      }).catch((err) => {
        // if(err.response.data.message != null && err.response.data.message != ''){
        //   this.$message.error({message:err.response.data.message, duration: 1000});
        // }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        // }        
        console.log(err);
      });
    },    
    deleteSwfw(data){           
      apiDeleteSwfwById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    saveFileSuccess(fileStatus){
      if(this.addDataSuccess && fileStatus){
        this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        this.findData();
      }else{
        this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
      }
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.findData()
    }     
  }
};
</script>
